import * as React from 'react';
import { Spin } from 'antd';
import { SpinProps } from 'antd/lib/spin';

import styles from './spinner.module.scss';

type Props = SpinProps;

const Spinner: React.FC<Props> = (props) => <Spin indicator={<div className={styles.spinIndicator} />} {...props} />;

export { Spinner };
